import React from "react";
import fondo from "../../images/fondo.png";
import { ImgFondo } from "./styles";

export const Fondo = () => {
  return (
    <>
      <ImgFondo src={fondo} alt="" />
    </>
  );
};
